// Where the "confirm your email" link lands.
import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ApiError, api } from '../api';
import { useSession } from '../session';
import { AuthCard, Banner } from '../ui';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const { refresh } = useSession();
  const token = params.get('token');
  const [state, setState] = useState<'working' | 'done' | 'failed'>('working');
  const [message, setMessage] = useState('');
  // React 18's StrictMode runs effects twice in development. The token is
  // single-use, so a second call would always fail and show an error on a
  // perfectly good link.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!token) {
      setState('failed');
      setMessage('That link is missing its code. Try copying the whole thing from the email.');
      return;
    }

    void (async () => {
      try {
        await api.verifyEmail(token);
        await refresh();
        setState('done');
      } catch (err) {
        setState('failed');
        setMessage(
          err instanceof ApiError ? err.message : 'That link could not be checked. Try again.'
        );
      }
    })();
  }, [token, refresh]);

  return (
    <AuthCard title="Confirming your email">
      {state === 'working' && <p className="muted">One moment…</p>}
      {state === 'done' && (
        <>
          <Banner kind="ok">Your email address is confirmed.</Banner>
          <Link to="/app">
            <button className="btn-primary full">Go to Dayboard</button>
          </Link>
        </>
      )}
      {state === 'failed' && (
        <>
          <Banner kind="error">{message}</Banner>
          <p className="footnote">
            Signed in already? <Link to="/app">Open Dayboard</Link> and ask for a new link.
          </p>
        </>
      )}
    </AuthCard>
  );
}
